const INPUT_PATH = /^inputs\[(\d+)\]\./;

/**
 * The Core answers a 422 pointing at the position of the input in the request
 * (`inputs[3].value`), but every form looks errors up by the input `hash`. The position
 * is resolved against the inputs that were sent; any other path is kept as it came.
 */
export const indexFormInputErrorsByHash = (
  errors: Record<string, string[]>,
  sentInputs: Array<{ hash: string }>,
): Record<string, string[]> =>
  Object.entries(errors).reduce<Record<string, string[]>>((acc, [path, messages]) => {
    const position = INPUT_PATH.exec(path)?.[1];
    const key = (position !== undefined ? sentInputs[Number(position)]?.hash : undefined) ?? path;

    return { ...acc, [key]: [...(acc[key] ?? []), ...messages] };
  }, {});
